import { render } from "./EditBusinessRuleActionCreateRecord.vue?vue&type=template&id=7f401dc2"
import script from "./EditBusinessRuleActionCreateRecord.vue?vue&type=script&lang=js"
export * from "./EditBusinessRuleActionCreateRecord.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__